// extracted by mini-css-extract-plugin
export default {"nav_list":"AuthNav_nav_list__SEW0N","nav_link":"AuthNav_nav_link__+kibW"};